import addedValueData2021 from '@/assets/data/values/2021';
import addedValueData2020 from '@/assets/data/values/2020';
import addedValueData2019 from '@/assets/data/values/2019';
import addedValueData2018 from '@/assets/data/values/2018';

export default {
  namespaced: true,
  state: () => ({
    list: {
      2018: addedValueData2018,
      2019: addedValueData2019,
      2020: addedValueData2020,
      2021: addedValueData2021
    }
  }),
  getters: {
    list: state => {
      return state.list;
    }
  }
};
